import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    SelectChangeEvent,
} from "@mui/material";
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosError, AxiosResponse } from "axios";
import { errorAlert } from "../../utils/alerts/alerts";
import { useSelector } from "react-redux";
import { City, ReduxUserReducerState } from "../../types/global";

type Props = {
    filterValues: Record<string, string>;
    setFilterValues: Dispatch<SetStateAction<Record<string, string>>>;
};

const AreaFilterBox = ({ filterValues, setFilterValues }: Props) => {
    const [loading, setLoading] = useState(true);
    const [areas, setAreas] = useState<City[]>([]);
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const handleChange: any = (e: SelectChangeEvent<string>) => {
        setFilterValues({
            ...filterValues,
            areas: e.target.value,
        });
    };
    useEffect(() => {
        EnhancedAxios(null, userToken)
            .get(`/areas?&sorts=-name&page=1&paginate=120`)
            .then((res: AxiosResponse) => {
                const newAreassForm = res.data.data.map((area: any) => {
                    const v = { id: area.id, name: area.name };
                    return v;
                });
                setAreas(newAreassForm);
                setLoading(false);
            })
            .catch((error: AxiosError) =>
                errorAlert(
                    "حدث خطا اثناء العرص التصنيفات برجاء اعادة تحميل الصفحة"
                )
            );
    }, []);
    return (
        <Box
            sx={{
                flex: "1",
                minWidth: "200px",
            }}
        >
            <FormControl fullWidth>
                <InputLabel>المنطقة</InputLabel>
                <Select
                    name="cities_filter"
                    value={filterValues.areas}
                    label="المنطقة"
                    onChange={handleChange}
                >
                    {areas?.map((option) => {
                        return (
                            <MenuItem value={option.id} key={option.id}>
                                {option.name}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </Box>
    );
};

export default AreaFilterBox;
